
























// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BaseAlertList from '@/ui/BaseAlertList.vue';
import TheFormDiscounts from '@/components/discounts/TheFormDiscounts.vue';
// Importing functions
import {postDiscount} from '@/ts/discounts/post-discount';
import {validateDiscount} from '@/ts/discounts/validate-discount';

export default {
    name: 'PageCategoriesCreate',
    components: {
        LayoutApp,
        BaseCard,
        BaseAlertList,
        TheFormDiscounts,
    },
    props: {},
    data() {
        return {
            data: Object(),
            errors: Array(),
            items: Array(),
            first_page: Boolean(true),
        };
    },
    methods: {
        onSubmit() {
            this.errors = [];

            validateDiscount(this.errors, this.data);

            if (this.errors.length === 0) {
                this.data.from = this.data.from.replace('T', ' ').replace('.000Z', '');
                this.data.to = this.data.to.replace('T', ' ').replace('.000Z', '');

                postDiscount(this.data, this.$route.params.id).then(() => {
                    this.$router.push({ name: 'discounts', params: { id: this.$route.params.id} });
                }).catch(() => {
                    this.data.from.replace(' ', 'T');
                    this.data.from = this.data.from + 'Z';
                    this.data.to.replace(' ', 'T');
                    this.data.to = this.data.to + 'Z';
                });
            }
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Ресторанти',
            to: { path: '/restaurants' },
        }, {
            text: 'Промоции',
            to: { name: 'discounts', params: { id: this.$route.params.id} },
        }, {
            text: 'Създаване',
        }];
        // Initializing the data object
        this.data = {
            text: '',
            from: '',
            to: '',
        };
        this.$store.dispatch('setLoadingOff');
    },
};
